import { Environment } from '@contracts';
import { CountryCode } from '@dayetopia/types';

/**
 * Gets the active environment, defaulting to 'development' if not set
 */
export const getActiveEnvironment = (): Environment => {
  return (process.env.GATSBY_ACTIVE_ENV as Environment) || 'development';
};

/**
 * Checks if the current environment is development.
 *
 * @returns {boolean} True if the environment is development, otherwise false.
 */
export const isDevelopmentEnvironment = (): boolean => {
  return getActiveEnvironment() === 'development';
};

/**
 * Checks if the current environment is test.
 *
 * @returns {boolean} True if the environment is test, otherwise false.
 */
export const isTestEnvironment = (): boolean => {
  return getActiveEnvironment() === 'test';
};

/**
 * Checks if the current environment is production.
 *
 * @returns {boolean} True if the environment is production, otherwise false.
 */
export const isProductionEnvironment = (): boolean => {
  return getActiveEnvironment() === 'prod';
};

/**
 * Checks if the FLEX_PAY feature should be shown.
 *
 * @returns {boolean} True if FLEX_PAY should be shown, otherwise false.
 */
export const isFlexPayEnabled = (): boolean => {
  return process.env.SHOW_FLEX_PAY === 'true';
};

/**
 * Checks if PayPal should be shown for the given country.
 *
 * @param {CountryCode} country - The country code to check
 * @returns {boolean} True if PayPal should be shown, otherwise false.
 */
export const isPaypalEnabled = (country?: CountryCode): boolean => {
  return process.env.SHOW_PAYPAL === 'true' && country !== CountryCode.BG;
};
